import React, { useState, useEffect } from 'react';
import { styled } from 'linaria/react';
import PaddingBox from '@uds/padding-box';
import { cssTheme } from '@uds/theme-utils';
import { Colorways } from '@uds/colorway';

import { QuestionProps } from './Elaborate';
import Question from './Question';

interface OuterProps {
  colorway: Colorways;
  hBaseline: number;
  duration?: number;
  questions: Array<QuestionProps>;
}

const StyledQuestions = styled.div<{ duration: number }>`
  margin: calc(${cssTheme.gu2} * -1) 0;
  --transition-duration: ${({ duration }) => `${duration}ms`};
`;

export const PureQuestions = ({ colorway, hBaseline, questions, duration = 300 }: OuterProps) => {
  const [selected, setSelected] = useState<number | null>(null);

  useEffect(() => {
    const defaultOpen = questions.findIndex((question) => question.defaultOpen === true);

    if (defaultOpen > -1) {
      setSelected(defaultOpen);
    }
  }, [questions, setSelected]);

  return (
    <PaddingBox>
      <StyledQuestions duration={duration}>
        {questions.map((q, i) => (
          <Question
            key={'Question_'.concat(String(i))}
            id={i}
            duration={duration}
            colorway={colorway}
            hBaseline={hBaseline}
            selected={selected}
            question={q.question}
            answer={q.answer}
            onChange={setSelected}
          />
        ))}
      </StyledQuestions>
    </PaddingBox>
  );
};

PureQuestions.displayName = 'Questions';

export default PureQuestions;
